// extracted by mini-css-extract-plugin
export default {"socialSignup":"social-login_socialSignup_skjpA","buttonSocial":"social-login_buttonSocial_EsS3V"};